import React from "react";

const WarningTriangleIcon = ({ className }) => (
  <svg
    xmlns='https://www.w3.org/2000/svg'
    viewBox='0 0 265.4766846 233.2780151'
    className={className || ""}
  >
    <path
      fill='#FFF'
      d='M12.528 233.278a12.571 12.571 0 0 1-10.855-6.266 12.575 12.575 0 0 1 0-12.533L121.882 6.267C124.118 2.4 128.276 0 132.739 0s8.622 2.401 10.855 6.266l120.21 208.212a12.574 12.574 0 0 1 .002 12.532 12.572 12.572 0 0 1-10.856 6.268H12.528z'
    />
    <path
      fill='#e01e5a'
      d='M12.527 223.278c-.888 0-1.75-.498-2.196-1.27a2.583 2.583 0 0 1 .003-2.533l120.21-208.208c.444-.77 1.306-1.267 2.194-1.267s1.75.498 2.196 1.268l120.21 208.21a2.58 2.58 0 0 1-.001 2.535 2.576 2.576 0 0 1-2.194 1.265H12.527z'
    />
    <g fill='#FFF'>
      <path d='M117.978 75.2c0-16.884 29.521-16.8 29.521 0l-7.743 88.76c0 6.995-13.793 7.015-13.793 0l-7.985-88.76z' />
      <ellipse cx='132.738' cy='189.373' rx='14.7' ry='15.005' />
    </g>
  </svg>
);

export default WarningTriangleIcon;
